module.exports = __webpack_public_path__ + "static/media/adjust_categories.103006af.mp4";